// extracted by mini-css-extract-plugin
module.exports = {"color-white":"#FFFFFF","colorWhite":"#FFFFFF","retina":"~\"(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dppx)\"","facebook":"_3YwyM","google":"_2BbaQ"};